import { useContext, useMemo } from "react";
import { SettingKey } from "@swagger/typescript-fetch-goflyer";
import { GoFlyerAdminContext } from "../contextApi/context";

/**
 * Whether to show image tag icons on search result thumbnails.
 * Defaults to true; hidden only when the user setting is explicitly false.
 */
export const useShowImageTagsInSearch = (): boolean => {
  const { state } = useContext(GoFlyerAdminContext);

  return useMemo(() => {
    const userSettings = state.gfAdminUser?.settings || [];
    const setting = userSettings.find(
      (s) => s?.setting?.settingKey === SettingKey.ShowImageTagsInSearch,
    );

    if (setting?.value === false || setting?.value === "false") {
      return false;
    }

    return true;
  }, [state.gfAdminUser?.settings]);
};
